import '../sass/hero-block.scss';
import './hero-block';
